import api from 'services/api';

function getUserFromStorage(key) {
  const user = JSON.parse(sessionStorage.getItem(key));
  return user;
}

function saveUserOnStorage(user) {
  sessionStorage.setItem('user', JSON.stringify(user));
}

async function login(Login, Senha) {
  let response = { user: null, error: null };
  response.user = getUserFromStorage('user');

  if ((!Login && !response.user) || response.user) return response;

  try {
    const { data } = await api.userLogin('Admin/Login', {
      Login,
      Senha,
    });
    if (data.Item) {
      response.user = { login: data.Item.Login, token: data.Item.Token };
      saveUserOnStorage(response.user);
    } else {
      throw new Error(data.Mensagem);
    }
  } catch (error) {
    console.error(error);
    response.user = null;
    response.error = error;
  } finally {
    return response;
  }
}

// eslint-disable-next-line import/no-anonymous-default-export
export default { login };
